import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Accordion, Grid, Table, Badge, Text, Checkbox, Button } from '@mantine/core';
import { Styles } from '../../../../components/tables/skutable/production-site/styles';
import { ActionModal } from '../../productDevelopment/actionModal';
import { ProductionLog } from '../../productDevelopment/productionSiteLogModal';
import { liquidBomChanges } from '../../../../constants';

const MaterialsStatusChangeTableVEAM = ({ statusDataList, type, save, accState, readOnly }) => {
  const [actionModal, setActionModal] = useState({ open: false, id: '' });
  const [logModal, setLogModal] = useState({ open: false, id: '' });
  const [imp_id, setImp_id] = useState(0);
  const [status, setStatus] = useState('');
  const [checked, setChecked] = useState(false);

  const [state, handlers] = useState({ initialItem: 0 });

  const Action = (item) => {
    return item.status === 'In Progress' || item.status === 'Not Started' ? (
      <Checkbox
        disabled={(item.status === 'In Progress' ? false : true) || readOnly}
        onChange={(event) => {
          setChecked(event.target.checked);
          setStatus(item.id);
          setActionModal({ open: true, id: item.id });
        }}
        label='Confirm and Close'
      />
    ) : item.manually_closed && item.status === 'Closed' ? (
      <Text>Manually Closed</Text>
    ) : (
      <Text>Automatic Closure</Text>
    );
  };

  const getLogs = (imp_id) => {
    setLogModal({ open: true, id: imp_id });
    setImp_id(imp_id);
  };

  useEffect(() => {
    let handlerObj = Object.values(accState).length > 0 ? accState : { initialItem: 0 };
    handlers(handlerObj);
  }, [accState]);

  const Logs = (id) => {
    return (
      <Button onClick={() => getLogs(id)} style={{ background: 'black', color: 'white' }}>
        View Logs
      </Button>
    );
  };

  const filteredData = (data) => {
    return data.map((item) => {
      let scope_selection_code = 'LIQ - ' + item.selection_number + ' - ' + item.selection_name;
      let Code = 'N/A',
        Description = 'N/A';

      if (type === 'Materials') {
        if (
          item.material_type === 'Existing Material' ||
          item.material_type === 'Remove Material'
        ) {
          Code = item.int_rfs_material_number ? item.int_rfs_material_number : 'N/A';

          Description = item.pack_mat_material_text ? item.pack_mat_material_text : 'N/A';
        } else if (item.material_type === 'New Material') {
          Code = item.new_material_code ? item.new_material_code : 'N/A';

          Description = item.new_material_description_intrfsml
            ? item.new_material_description_intrfsml
            : 'N/A';
        }
      } else {
        if (
          item.bom_changes?.includes(liquidBomChanges.thickness) &&
          item.liquid_type === 'New Liquid'
        ) {
          Code = item.new_material_code;
          Description = item.new_material_description_intrfsml;
        } else {
          if (item.liquid_type === 'Add Liquid') {
            Code = item.new_material_code;
            Description = item.new_material_description_intrfsml;
          } else {
            Code = item.liquid_code;
            Description = item.liquid_description;
          }
        }
      }

      return {
        Code: Code ? Code : 'N/A',
        Description: Description ? Description : 'N/A',
        Plant: item.plant,
        Status: (
          <Badge
            color={
              item.status === 'In Progress' ? 'yellow' : item.status === 'Closed' ? 'green' : 'gray'
            }
            size='lg'
          >
            {' '}
            {item.status}{' '}
          </Badge>
        ),
        Action: Action(item),
        Logs: Logs(item.id),
        'SLA Date': moment(item.sla_date).format('YYYY-MM-DD'),
        'Step Finished': item.finished_date
          ? moment(item.finished_date).format('YYYY-MM-DD')
          : item.status,
        scope_selection_code: scope_selection_code,
        scope_id: item.scope_id,
      };
    });
  };

  const filteredDataRes = filteredData(statusDataList);

  const HtmlRenderedData = ({ type }) => {
    let Title = type.substring(0, type.length - 1);
    const heads = (
      <thead>
        <tr id='header-row'>
          <th>{Title} Code</th>
          <th>{Title} Description</th>
          <th>Plant</th>
          <th>Status</th>
          <th>Action</th>
          <th>Logs</th>
          <th>Step Deadline</th>
          <th>Step Finished</th>
        </tr>
      </thead>
    );

    const Materials = () => {
      const rowsData = filteredDataRes.map((item, index) => (
        <tr key={index}>
          {Object.values(item).map((it, i) => {
            return (
              i < 8 && (
                <td key={i} style={{ padding: '0.8rem !important' }}>
                  {it}
                </td>
              )
            );
          })}
        </tr>
      ));

      return (
        <Table>
          {heads}
          <tbody>{rowsData}</tbody>
        </Table>
      );
    };

    const Liquids = () => {
      let arr = [];
      filteredDataRes.map((item) =>
        arr.includes(item.scope_id) === false ? arr.push(item.scope_id) : '',
      );

      const a = arr.map((arr_item) => {
        return filteredDataRes.filter((item) => {
          return item.scope_id === arr_item;
        });
      });

      return (
        <Accordion value={state} onChange={handlers}>
          {a.map((item, index) => {
            return (
              <Accordion.Item className='scope-label' key={`key_${index}`} value={`key_${index}`}>
                <Accordion.Control>{`${item[0].scope_selection_code}`}</Accordion.Control>
                <Accordion.Panel>
                  <Grid>
                    <Grid.Col span={12}>
                      <Styles>
                        <div style={{ overflow: 'auto' }}>
                          <Table>
                            {heads}
                            <tbody>
                              {item.map((item, index) => (
                                <tr key={index}>
                                  {Object.values(item).map((it, i) => {
                                    return (
                                      i < 8 && (
                                        <td
                                          key={i}
                                          style={{
                                            padding: '0.8rem !important',
                                          }}
                                        >
                                          {it}
                                        </td>
                                      )
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </Styles>
                    </Grid.Col>
                  </Grid>
                </Accordion.Panel>
              </Accordion.Item>
            );
          })}
        </Accordion>
      );
    };

    return type === 'Liquids' ? <Liquids /> : <Materials />;
  };

  return (
    <Styles>
      <div style={{ overflow: 'auto' }}>
        <HtmlRenderedData type={type} />
      </div>

      {actionModal && (
        <ActionModal
          actionModal={actionModal}
          setActionModal={setActionModal}
          save={save}
          status_id={status}
          state={state}
        />
      )}

      {logModal && (
        <ProductionLog
          logModal={logModal}
          setLogModal={setLogModal}
          id={imp_id}
          type='Material Status Change'
        />
      )}
    </Styles>
  );
};

export default MaterialsStatusChangeTableVEAM;
